import { isSaasAdmin } from "../helpers/profile";
import { useCurrentProfile } from "./queries/profile";

export const useIsSaasAdmin = () => {
  const { data: currentProfile } = useCurrentProfile();

  return isSaasAdmin(currentProfile);
};
